import { Ref, useCallback, useLayoutEffect, useRef, useState } from 'react';
import debounce from 'lodash/debounce';

export interface SizeObservableSize {
   width: number,
   height: number
}

export const useResizeObserver = (): [Ref<any>, SizeObservableSize | null] => {

   const [size, setSize] = useState<SizeObservableSize | null>(null);
   const resizeObserverRef = useRef<any>(null);

   const setSizeDebounced = debounce(setSize, 100);

   const onResize = useCallback(entries => {
      const { width, height } = entries[0].contentRect;
      if (width !== 0 || height !== 0) {
         setSizeDebounced({ width, height });
      }
   }, []);

   const ref: Ref<any> = useCallback(
      (node) => {
         if (node !== null) {
            if (resizeObserverRef.current != null) {
               resizeObserverRef.current.disconnect();
            }
            resizeObserverRef.current = new (window as any).ResizeObserver(onResize);
            resizeObserverRef.current.observe(node);
         }
      },
      [onResize]
   );

   useLayoutEffect(() => () => {
      if (resizeObserverRef.current) {
         resizeObserverRef.current.disconnect();
      }
   }, []);

   return [ref, size];
};
